import { render, staticRenderFns } from "./pile-swap-record-table.vue?vue&type=template&id=bf9d57ee&scoped=true"
import script from "./pile-swap-record-table.vue?vue&type=script&lang=js"
export * from "./pile-swap-record-table.vue?vue&type=script&lang=js"
import style0 from "./pile-swap-record-table.vue?vue&type=style&index=0&id=bf9d57ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d57ee",
  null
  
)

export default component.exports